// Port of api/fuel/app/classes/filter/search/games/filters/query/collection/exclude/prevowned.php
export default {
	name: 'collection.exclude.prevowned',
	priority: 84,
	require: function(config, filter, data) {
		return filter.collection && filter.collection.exclude && filter.collection.exclude.prevowned
	},
	run: function(config, filter, data, query) {
		query.where('ce.collection_prevowned', '=', 1)
		query.notexist('collection', 'ce')
	}
}
